
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { Badge, Divider, Grid, IconButton, Paper, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Employee, Office } from '../../interfaces/s10Corporation.interface';
import { useEffect, useRef, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import ImageProfileCircle from '../../components/ImageProfileCircle';
import { ApprovalEmployees } from '../../interfaces/auth.interface';
import BusinessIcon from '@mui/icons-material/Business';

type ChangeChildAction = "employees" | "offices";

interface TreeNode {
    nodeDatum: Office | Employee[];
    toggleNode: any;
    isAdmin?: boolean;
}

interface TreeNodeOrganization extends TreeNode {
    nodeDatum: Office;
    changeChildren: (nodeDatum: Office, action: ChangeChildAction) => void;
    setNodeToDelete: (nodeDatum: Office) => void;
    setNodeToEdit: (nodeDatum: Office) => void;
}

interface TreeNodeEmployee extends TreeNode {
    nodeDatum: Employee[];
    // drawLine: boolean;
    setNodeToDelete: (nodeDatum: Employee) => void
}

interface TreeNodeAddOption extends TreeNode {
    nodeDatum:  Office & { onClickAddOption: () => void },
}

export const NodeOrgnization = ({ nodeDatum, toggleNode, changeChildren, isAdmin, setNodeToDelete, setNodeToEdit }: TreeNodeOrganization) => {

    const nodeRef = useRef<any>();
    
    const {employees} = useSelector((state: RootState) => state.userRequests).approvalGroups;
    const [employeeData, setEmployeeData] = useState<ApprovalEmployees | undefined>()

    const handleClick = (action: ChangeChildAction) => {
        changeChildren(nodeDatum, action);
        toggleNode(nodeRef)
        if (nodeDatum.currentChildView === null || nodeDatum.currentChildView === action) {
            const node = document.getElementById(`${nodeDatum.Id}`);
            if (node) {
              const container = node.closest('.p-organizationchart-node-content');
              if (container) {
                const link = container.querySelector('.p-node-toggler');
                if (link) {
                  (link as HTMLAnchorElement).click();
                }
              }
            }
        }
    };

    
    const checkElement = (data: Office) => {
        // const childrenMustExists = data.currentChildView !== null;
        // const childrenExists = !!document.querySelector(`.parent-${data.Id}-child`);
        const isVisible = checkVisibilityByClass(`.parent-${data.Id}-child`)
        // p-icon p-node-toggler-icon
        // p-icon p-node-toggler-icon
        if (!isVisible) {
            const node = document.getElementById(`${data.Id}`);
            if (node) {
              const container = node.closest('.p-organizationchart-node-content');
              if (container) {
                const link = container.querySelector('.p-node-toggler');
                if (link) {
                    (link as HTMLAnchorElement).click();
                }
              }
            }
        }
    };
    
    
    const checkVisibilityByClass = (elementClass: string) => {
        const targetElement = document.querySelector(elementClass);
        if (targetElement) {
          let parentElement: HTMLElement | null | undefined = targetElement.parentElement;
          while (parentElement) {
            if (parentElement.tagName === 'TD') {
              parentElement = parentElement.parentElement;
            }
            if ( parentElement && parentElement.tagName === 'TR' 
                && parentElement.classList.contains('p-organizationchart-nodes')
            ) {
              break;
            }
            parentElement = parentElement?.parentElement;
          }
          if (parentElement && parentElement.classList.contains('p-organizationchart-nodes')) {
            const visibility = window.getComputedStyle(parentElement).visibility;
            if (visibility === 'hidden') {
              return false;
            } else {
              return true;
            }
          } else {
            return null;
          }
        } else {
          return null;
        }
    }

    useEffect(() => {
        checkElement(nodeDatum);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeDatum, nodeDatum.children]);

    useEffect(() => {
        const principalEmployeeCode = nodeDatum?.principalEmployee?.EmployeeCode;
        if (!principalEmployeeCode) {
            return;
        }
        const employeeData = employees.find(em => em.CodIdentificador === principalEmployeeCode);
        setEmployeeData(employeeData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [employees]);

    const isPrincipalNode = nodeDatum?.parents?.length === 0;

    

    return (
        <Grid
            id={`${nodeDatum.Id}`}
            ref={nodeRef}
            container 
            direction="column"
            className={`parent-${nodeDatum.ParentId}-child`}

            style={{zIndex: 900, position: "relative"}}
        >
            <Paper elevation={3}>
                <Grid
                    container
                    item
                    direction="column"
                    style={{
                        // borderRadius: "0.5rem",
                        // backgroundColor: "#EFF4F6",
                        padding: "0.5rem",
                        width: "8.5rem",
                        // height: "14rem",
                        alignItems: "center",
                        position: "relative",
                    }}
                >   
                    {isAdmin === true && nodeDatum.Id && <Grid 
                        container
                        item 
                        direction="row"
                        justifyContent="space-between"
                        style={{position: "absolute", top: "-.2rem", padding: 0}}
                    >
                        <IconButton 
                            aria-label="modify" 
                            onClick={() => {
                                setNodeToEdit(nodeDatum);
                            }}
                        >
                            <EditIcon />
                        </IconButton>
                        <IconButton 
                            aria-label="delete" 
                            onClick={() => {
                                setNodeToDelete(nodeDatum);
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>

                    </Grid>}
                    <Grid item>
                        { isPrincipalNode
                            ? <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 22H9.2C8.07989 22 7.51984 22 7.09202 22.218C6.71569 22.4097 6.40973 22.7157 6.21799 23.092C6 23.5198 6 24.0799 6 25.2V42M33 22H38.8C39.9201 22 40.4802 22 40.908 22.218C41.2843 22.4097 41.5903 22.7157 41.782 23.092C42 23.5198 42 24.0799 42 25.2V42M33 42V12.4C33 10.1598 33 9.03969 32.564 8.18404C32.1805 7.43139 31.5686 6.81947 30.816 6.43597C29.9603 6 28.8402 6 26.6 6H21.4C19.1598 6 18.0397 6 17.184 6.43597C16.4314 6.81947 15.8195 7.43139 15.436 8.18404C15 9.03969 15 10.1598 15 12.4V42M44 42H4M22 14H26M22 22H26M22 30H26" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            : <ImageProfileCircle
                                width='3rem'
                                height='3rem'
                                ruc={employeeData?.RUCEmpresa as any}
                                userId={employeeData?.CodIdentificador as any}
                                userName={employeeData?.Descripcion || "?"}
                            />
                        }
                    </Grid>
                    <Grid 
                        item
                        style={{
                            width: "100%", 
                            marginTop: ".5rem", 
                            color: "#E8E8E8",
                        }}
                    >
                        <Typography variant='h6' fontSize=".7rem">
                            {nodeDatum.Name}
                        </Typography>
                    </Grid>
                    {!isPrincipalNode && <Divider 
                        style={{
                            width: "100%", 
                            marginTop: ".5rem", 
                            marginBottom: ".5rem",
                            color: "#E8E8E8",
                        }}
                    />}
                    {!isPrincipalNode && <>
                        <Grid item>
                            <Typography variant='h6' fontSize=".6rem">
                                {employeeData?.Cargo || '-'}
                            </Typography>
                        </Grid>
                        <Divider 
                            style={{
                                width: "100%", 
                                marginTop: ".5rem", 
                                marginBottom: ".25rem",
                                color: "#E8E8E8",
                            }}
                        />
                        <Grid item marginTop=".5rem">
                            <Typography variant='h6' fontSize=".7rem" style={{minHeight: "3em"}}>
                                {employeeData?.Descripcion}
                            </Typography>
                        </Grid>
                    </>}
                    <Divider 
                        style={{
                            width: "100%", 
                            marginTop: ".5rem", 
                            marginBottom: ".5rem",
                            color: "#E8E8E8",
                        }}
                    />
                    <Grid 
                        container
                        item 
                        direction="row"
                        justifyContent={nodeDatum.ParentId !== undefined ? "space-between" : "center"}
                    >
                        <IconButton 
                            aria-label="offices"
                            style={{
                                height: "2rem",
                                width: "2rem",
                                backgroundColor: nodeDatum.currentChildView === "offices" 
                                    ? "#DDE7EC"
                                    : "#EFF4F6"
                            }}
                            onClick={() => handleClick("offices")}
                        >
                            
                            <Badge 
                                badgeContent={nodeDatum.offices?.filter(o => o.isAddOption !== true)?.length || 0} 
                                color="primary"
                            >
                                <BusinessIcon fontSize='small' />
                            </Badge>
                        </IconButton>
                        {nodeDatum.ParentId !== undefined && <IconButton 
                            color='primary'
                            aria-label="employees"
                            style={{
                                height: "2rem",
                                width: "2rem",
                                backgroundColor: nodeDatum.currentChildView === "employees" 
                                    ? "#DDE7EC"
                                    : "#EFF4F6",
                                color: "black"
                            }}
                            onClick={() => handleClick("employees")}
                        >
                            {/* <Badge badgeContent={nodeDatum.Employees?.filter(e => e.IsPrincipal !== true)?.length || 0} color="primary"> */}
                            <Badge badgeContent={nodeDatum.Employees?.length || 0} color="primary">
                                <GroupsOutlinedIcon fontSize='small' />
                            </Badge>
                        </IconButton>}

                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
};

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const NodeEmployee = ({ nodeDatum, toggleNode, isAdmin, setNodeToDelete }: TreeNodeEmployee) => {
    const {employees} = useSelector((state: RootState) => state.userRequests).approvalGroups;
    const nodeRef = useRef<HTMLDivElement>(null);

    const handleClick = async (inputRef: any) => {
        await delay(500);  // Retrasa 500 ms
        if (inputRef.current) {
            inputRef.current.click();
        }
    };

    useEffect(() => {
        // Verifica que el nodo seleccionado y la referencia existan
        if (!nodeDatum.find(e => e.isSelected === true) || !nodeRef.current) {
            return;
        }
        toggleNode()
        handleClick(nodeRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeDatum]);
    
    return (
        <Grid 
            ref={nodeRef}
            position="relative"
            style={{ 
                paddingLeft: "1.5rem",
            }}
        >
        {nodeDatum.map( (e: Employee, i: number) => {

            const employeeData = {...e, ...employees.find(em => em.CodIdentificador === e.EmployeeCode)};
            
            return (
                <Grid
                    key={`${e.parentData?.Id}-${e.Id}`}
                    className={`parent-${e.parentData?.Id}-child`}
                    container 
                    direction="column"
                    onClick={() => toggleNode()}
                    style={{
                        padding: "0rem",
                        width: "12rem",
                        alignItems: "flex-start",
                        position: "relative",
                        marginLeft: "1rem",
                    }}
                >
                    {/*artilugio para tapar linea superior original */}
                    {i === 0 &&<div 
                        style={{
                        position: "absolute",
                            left: "-40%",
                            top: "-9px", 
                            height: "10px", 
                            width: "100%",
                            backgroundColor: "white",
                        }}
                    />}
                    {/* linea de union vertical entre nodos */}
                    {(i + 1) < nodeDatum.length && nodeDatum.length > 1 && (
                        <div 
                            style={{
                            position: "absolute",
                            left: "-1.2rem",
                            bottom: "-50%", 
                            height: "110%", 
                            width: "1px",
                            backgroundColor: "#10617B",
                            }}
                        />
                    )}
            
                    {/* linea media horizontal nodo */}
                    <div 
                        style={{
                            position: "absolute",
                            left: "-1.2rem",
                            top: "50%",
                            height: "1px",
                            width: "2rem",
                            backgroundColor: "#10617B",
                            zIndex: 1,
                        }}
                    />
            
                    {/* linea top del nodo */}
                    {i === 0 && (
                        <div
                            style={{
                                position: "absolute",
                                left: "-1.2rem",
                                top: "-10px",
                                height: "1px",
                                width: "70%",
                                backgroundColor: "#10617B",
                            }}
                        />
                    )}
                    
                    {/* linea de mas de la mitad hasta arriba pt 2*/}
                    {i === 0 && e.parentData && (
                        <div
                            style={{
                            position: "absolute",
                            left: "-1.2rem",
                            top: "-10px",
                            height: "50%",
                            width: "1.1px",
                            backgroundColor: "#10617B",
                            }}
                        />
                    )}
                    {/* linea de mitad hasta arriba pt 1*/}
                    {i === 0 && e.parentData && (
                        <div
                            style={{
                            position: "absolute",
                            left: "-1.2rem",
                            top: "0",
                            height: "50%",
                            width: "1.1px",
                            backgroundColor: "#10617B",
                            }}
                        />
                    )}
                    <Paper elevation={3} style={{zIndex: 990}}>
                        <Grid
                            container
                            item
                            direction="column"
                            style={{
                                // borderRadius: "0.5rem",
                                // backgroundColor: "#EFF4F6",
                                padding: "0.5rem",
                                width: "8.5rem",
                                // height: "13.5rem",
                                alignItems: "center",
                                position: "relative",
                                
                            }}
                        >   
                            {isAdmin === true && 
                                <Grid 
                                    container
                                    item 
                                    direction="row"
                                    justifyContent="end"
                                    style={{position: "absolute", top: "-.2rem", right: "-.5rem"}}
                                >
                                    <IconButton 
                                        aria-label="delete" 
                                        onClick={() => {
                                            setNodeToDelete({...employeeData, ...e} as any);
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>

                                </Grid>
                            }
                            <Grid item>
                                <ImageProfileCircle
                                    width='3rem'
                                    height='3rem'
                                    ruc={employeeData?.RUCEmpresa as any}
                                    userId={employeeData?.CodIdentificador as any}
                                    userName={employeeData?.Descripcion || "?"}
                                />
                            </Grid>
                            
                            <Divider 
                                style={{
                                    width: "100%", 
                                    marginTop: ".5rem", 
                                    marginBottom: ".5rem",
                                    color: "#E8E8E8",
                                }}
                            />
                                <Grid item>
                                    <Typography variant='h6' fontSize=".6rem">
                                        {(employeeData as any)?.IsPrincipal ? 'Responsable ' : '' + (employeeData?.Cargo || '-')}
                                    </Typography>
                                </Grid>
                                <Divider 
                                    style={{
                                        width: "100%", 
                                        marginTop: ".5rem", 
                                        marginBottom: ".25rem",
                                        color: "#E8E8E8",
                                    }}
                                />
                                <Grid item marginTop=".5rem">
                                    <Typography variant='h6' fontSize=".7rem" style={{minHeight: "3em"}}>
                                        {employeeData?.Descripcion}
                                    </Typography>
                                </Grid>
                        </Grid>
                    </Paper>
                    <Grid container item direction="row" height={"1rem"}>
                        <Grid item xs={6} height="1rem" />
                        {/* <Grid item xs={6} height="1rem" style={(i + 1) < nodeDatum.length ? {borderLeft: "2px solid #10617B"} : undefined} /> */}
                    </Grid>
                </Grid>
                
                
                
                
                
                
                
                
                
                // <Grid 
                //     key={`${e.parentData?.Id}-${e.Id}`}
                //     className={`parent-${e.parentData?.Id}-child`}
                //     container 
                //     direction="column"
                //     onClick={() => toggleNode()}
                //     style={{
                //         padding: "0rem",
                //         width: "12rem",
                //         // height: "4.5rem",
                //         alignItems: "flex-start",
                //         position: "relative",
                //     }}
                //     // style={{position: "fixed"}}
                // >
                //     <Paper elevation={3}>
                //         <Grid
                //             container
                //             item
                //             direction="row"
                //             style={{
                //                 padding: "0.5rem",
                //                 width: "100%",
                //                 height: "4.5rem",
                //                 alignItems: "flex-start",
                //                 position: "relative",
                //             }}
                //             alignContent="start"
                //         > 
                //             <Grid
                //                 container
                //                 item
                //                 padding={0}
                //                 margin={0}
                //                 width="2rem"
                //                 marginTop=".2rem"
                //             >
                //                 <ImageProfileCircle
                //                     height='2rem'
                //                     width='2rem'
                //                     ruc={employeeData?.RUCEmpresa as any}
                //                     userName={employeeData?.Descripcion || e.EmployeeCode}
                //                     userId={e.EmployeeCode}
                //                 />
                //             </Grid>
                //             <Grid container direction={"column"} width={"8rem"}>
                //                 {isAdmin === true && <Grid 
                //                     container
                //                     item 
                //                     direction="row"
                //                     justifyContent="end"
                //                     style={{position: "absolute", top: "-.2rem", right: "-.5rem"}}
                //                 >
                //                     <IconButton 
                //                         aria-label="delete" 
                //                         onClick={() => {
                //                             setNodeToDelete({...employeeData, ...e} as any);
                //                         }}
                //                     >
                //                         <DeleteIcon />
                //                     </IconButton>

                //                 </Grid>}
                //                 <Grid item marginTop=".5rem" textAlign="center">
                //                     <Typography 
                //                         variant='h6' 
                //                         fontSize=".8rem" 
                //                         padding="0 .5rem"
                //                         style={{
                //                             display: "-webkit-box",
                //                             WebkitLineClamp: 2,
                //                             WebkitBoxOrient: "vertical",
                //                             overflow: "hidden",
                //                             textOverflow: "ellipsis",
                //                         }}
                //                     >
                //                         {employeeData?.Descripcion || e.EmployeeCode}
                //                     </Typography>
                //                     {e.IsPrincipal && 
                //                     <Typography variant='h6' fontSize=".7rem">
                //                         Responsable
                //                     </Typography>}
                //                 </Grid>
                //             </Grid>
                //         </Grid>
                //     </Paper>
                //     <Grid container item direction="row" height={"1rem"}>
                //         <Grid item xs={6} height="1rem" />
                //         <Grid item xs={6} height="1rem" style={(i + 1) < nodeDatum.length ? {borderLeft: "2px solid #10617B"} : undefined} />
                //     </Grid>
                // </Grid>
                )
            })}
        </Grid>
    );
}

export const NodeAddOption = ({ nodeDatum, toggleNode }: TreeNodeAddOption) => {
    return (
        <Paper elevation={3}>
        <Grid
            container
            className={`parent-${nodeDatum.ParentId}-child`}
            direction="row"
            style={{
                borderRadius: "0.5rem",
                // backgroundColor: "#EFF4F6",
                padding: ".5rem 0 .2rem 0",
                width: "8.5rem",
                // height: "3.5rem",
                alignItems: "center",
                textAlign: "center",
                // position: "fixed",
            }}
        >   
            <Typography variant='h6' fontSize=".8rem" width="100%" margin={0}>
                Agregar {nodeDatum.parentData?.currentChildView === "employees" 
                                        ? "Colaborador" 
                                        : "Área"}
            </Typography>
            <Grid item width="100%" margin={0}>
                <IconButton 
                    style={{margin: 0}}
                    aria-label="add" 
                    onClick={() => {
                        nodeDatum.onClickAddOption();
                        // toggleNode()                        
                    }}
                >
                    <AddIcon />
                </IconButton>
            </Grid>
        </Grid>
        </Paper>
    );
}

